import backgroundImage from '../imgs/bg.jpg';
import contact from '../imgs/Frame 4605.png';
import fb from '../imgs/Facebooknew.png';
import zl from '../imgs/Zalo.png';
import ins from '../imgs/Instagram new.png';
import follow from '../imgs/Follow Us.png';

export default function HERO_SECTION() {
  return (
    <div
      className="relative bg-cover bg-center h-[955px]"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-20 z-0" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B1D26] to-black/30 z-0" />

      {/* Sidebar icon */}
      <div
  className={`
    absolute top-[270px] right-[-15px] z-20
    flex flex-col items-center space-y-6
    md:top-1/2 md:right-auto md:left-10 md:w-auto md:h-auto md:transform md:-translate-y-[90%]
  `}
>
  {/* Follow Us text rotated and centered */}
  <div className="rotate-90 text-white text-[12px] md:text-[22px] font-medium whitespace-nowrap mb-2 -translate-x-[-3px] md:-translate-x-[-3px] md:mt-[4px] md:mb-[40px]">
    Follow Us
  </div>

  <a href="https://zalo.me/0986908480" target="_blank" >
    <img src={zl} alt="Zalo" className="w-5 h-5 md:w-[32px] md:h-[32px]" />
  </a>
  <a href="https://www.facebook.com/cleverhospitalitymanagement/" target="_blank" rel="noopener noreferrer">
    <img src={fb} alt="Facebook" className="w-5 h-5 md:w-[32px] md:h-[32px]" />
  </a>
  <a href="https://www.facebook.com/cleverhospitalitymanagement/" target="_blank" rel="noopener noreferrer">
    <img src={ins} alt="Instagram" className="w-5 h-5 md:w-[32px] md:h-[32px]" />
  </a>
</div>






      {/* Main Content (Title + Subtitle) */}
      <div className="relative z-10 flex flex-col justify-start pt-[100px] px-4 md:px-[300px] md:pt-[150px]">
        <div className="max-w-4xl mx-auto md:mx-0 text-center md:text-left px-4 md:px-0">
          {/* Thanh vàng + subheading */}
          <div className="flex justify-center md:justify-start items-center space-x-4 mb-3">
            <div className="w-[60px] h-0.5 bg-yellow-400" />
            <h3 className="text-yellow-400 uppercase tracking-[0.2em] text-sm md:text-md whitespace-nowrap">
              Where you go is a key
            </h3>
          </div>

          {/* Heading chính */}
          <h1 className="text-white font-miller text-[30px] leading-tight md:text-[65px] md:leading-snug mb-6 text-left md:text-left">
            Lying In The Arms
            <br className="block" />
            Of Mother Nature
          </h1>
        </div>


        {/* Right Text: Mobile only */}
        <div className="block md:hidden px-2 text-white text-justify leading-relaxed mt-4 animate-fade-in-up text-sm">
          <p className="mb-2 indent-4">
            Given Vietnam tourism a key factor of the economy, we understand the popular and urgent needs of investors, the landlord and business owners who wish to build their own sanctuaries for not only commercial purposes, but also for themselves.
          </p>
          <p className="mb-2 indent-4">
            Most of small and medium scale investors find it difficult to do everything by themselves, from legal processes, concept idea building to construction and operation implementing… It’s a big black hole, indeed. Out-sourcing seems pretty much a good idea since there are quite a few choices among consultant agencies. Foreign consultants are too pricey, while they have a little insight of how things actually run in Vietnam. This might potentially cost a lot of time and finance for investor who eager to build right product, right business for right customers.
          </p>
          <p className="indent-4">
            Clever offers consulting services for both all inclusive package or specific phases of a hospitality project, giving investor flexible choices of cooperation to fit with their own plan at reasonable cost and utmost insights.
          </p>
        </div>
      </div>

      {/* Right Text: Desktop only */}
      <div className="hidden md:block absolute right-[50px] top-[500px] max-w-xl text-white text-justify leading-relaxed animate-fade-in-up">
        <p className="mb-2 indent-5">
          Given Vietnam tourism a key factor of the economy, we understand the popular and urgent needs of investors, the landlord and business owners who wish to build their own sanctuaries for not only commercial purposes, but also for themselves.
        </p>
        <p className="mb-2 indent-5">
          Most of small and medium scale investors find it difficult to do everything by themselves, from legal processes, concept idea building to construction and operation implementing… It’s a big black hole, indeed. Out-sourcing seems pretty much a good idea since there are quite a few choices among consultant agencies. Foreign consultants are too pricey, while they have a little insight of how things actually run in Vietnam. This might potentially cost a lot of time and finance for investor who eager to build right product, right business for right customers.
        </p>
        <p className="indent-5">
          Clever offers consulting services for both all inclusive package or specific phases of a hospitality project, giving investor flexible choices of cooperation to fit with their own plan at reasonable cost and utmost insights.
        </p>
      </div>

      {/* Top Right Nav (Desktop only) */}
      <div className="hidden md:flex absolute top-[165px] right-[50px] z-20 items-center space-x-6 animate-fade-in-up">
        <div className="flex flex-col text-white text-lg space-y-10 text-right">
          <div>About us</div>
          <div>What we do</div>
          <div>Our products</div>
        </div>
        <div className="h-40 border-r border-white opacity-50" />
      </div>
    </div>
  );
}